import { Controller } from "stimulus";
import NotificationModule from "./shared_modules/notification_module.js";

export default class extends Controller {
  static values = { url: String };

  connect() {
    this.notifications = new NotificationModule(null);
  }

  reupload(event) {
    event.preventDefault();

    const button = event.currentTarget;
    if (button.disabled) return;

    button.disabled = true;

    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        Accept: "application/json",
      },
    })
      .then((response) =>
        response.json().then((data) => ({
          ok: response.ok,
          data,
        }))
      )
      .then(({ ok, data }) => {
        if (ok) {
          this.notifications.success(data.message || "Re-upload initiated");
        } else {
          this.notifications.error(data.error || "Failed to initiate re-upload");
        }
      })
      .catch(() => {
        this.notifications.error("Failed to initiate re-upload");
      })
      .finally(() => {
        button.disabled = false;
      });
  }
}
